// Centralized status configuration for deployment lifecycle

export const DeploymentStatus = {
  INITIATING: 'initiating',
  PROVISIONING: 'provisioning',
  SSH: 'ssh',
  INSTALLING: 'installing',
  CONNECTING: 'connecting',
  VERIFYING: 'verifying',
  RUNNING: 'running',
  FAILED: 'failed',
  STOPPED: 'stopped',
  REMOVING: 'removing'
} as const

export type DeploymentStatusType =
  (typeof DeploymentStatus)[keyof typeof DeploymentStatus]

// Key-value pair of status enum to user-facing text
export const statusTextMap: Record<DeploymentStatusType, string> = {
  initiating: 'Initiating deployment...',
  provisioning: 'Setting up agent home...',
  ssh: 'Establishing SSH connection...',
  installing: 'Downloading AI engine...',
  connecting: 'Setting up communication channel...',
  verifying: 'Awaiting pairing code...',
  running: 'Live',
  failed: 'Connection Failed',
  stopped: 'Paused',
  removing: "Removing"
}

// UI configuration for status display
export const statusConfig = {
  initiating: {
    label: statusTextMap.initiating,
    color: 'bg-indigo-50/10 text-indigo-400 border-indigo-900/50',
    pingColor: 'bg-indigo-500',
  },
  provisioning: {
    label: statusTextMap.provisioning,
    color: 'bg-blue-50/10 text-blue-400 border-blue-900/50',
    pingColor: 'bg-blue-500',
  },
  ssh: {
    label: statusTextMap.ssh,
    color: 'bg-orange-50/10 text-orange-400 border-orange-900/50',
    pingColor: 'bg-orange-500',
  },
  installing: {
    label: statusTextMap.installing,
    color: 'bg-purple-50/10 text-purple-400 border-purple-900/50',
    pingColor: 'bg-purple-500',
  },
  connecting: {
    label: statusTextMap.connecting,
    color: 'bg-teal-50/10 text-teal-400 border-teal-900/50',
    pingColor: 'bg-teal-500',
  },
  verifying: {
    label: statusTextMap.verifying,
    color: 'bg-yellow-50/10 text-yellow-400 border-yellow-900/50',
    pingColor: 'bg-yellow-500',
  },
  running: {
    label: statusTextMap.running,
    color: 'bg-green-50/10 text-green-400 border-green-900/50',
    pingColor: 'bg-green-500',
  },
  stopped: {
    label: statusTextMap.stopped,
    color: 'bg-slate-100/10 text-slate-400 border-slate-800',
    pingColor: 'bg-slate-500',
  },
  failed: {
    label: statusTextMap.failed,
    color: 'bg-red-50/10 text-red-400 border-red-900/50',
    pingColor: 'bg-red-500',
  },
} as const
